module.exports = __webpack_public_path__ + "images/101_160.jpg";